// Bilingual content for the footer feature strip modals.
export const FOOTER_FEATURES = {
  confiance: {
    fr: {
      title: "Confiance", subtitle: "Transactions sécurisées",
      desc: "La confiance est au cœur d'agoomarket. Chaque achat est protégé et chaque vendeur est vérifié avant de vendre.",
      how: ["Les vendeurs sont vérifiés avant de publier.", "Votre commande est suivie et traçable de A à Z.", "Le paiement à la livraison est possible."],
      functions: ["Badge « Vendeur vérifié »", "Avis authentiques avec badge « Achat vérifié »", "Historique complet des statuts de commande"],
    },
    en: {
      title: "Trust", subtitle: "Secure transactions",
      desc: "Trust is at the heart of agoomarket. Every purchase is protected and every seller is verified before selling.",
      how: ["Sellers are verified before listing.", "Your order is tracked end to end.", "Cash on delivery is available."],
      functions: ["\"Verified seller\" badge", "Authentic reviews with \"Verified purchase\" badge", "Full order status history"],
    },
  },
  pour_tous: {
    fr: {
      title: "Pour tous", subtitle: "Acheteurs et vendeurs",
      desc: "agoomarket est pensé pour tout le monde : acheteurs, vendeurs et livreurs y trouvent leur place.",
      how: ["Créez un compte gratuit en quelques secondes.", "Choisissez votre rôle : acheteur, vendeur ou livreur.", "Accédez à un espace dédié à votre profil."],
      functions: ["Tableaux de bord acheteur, vendeur et livreur", "Boutiques personnalisées pour les vendeurs", "Inscription 100% gratuite"],
    },
    en: {
      title: "For everyone", subtitle: "Buyers and sellers",
      desc: "agoomarket is built for everyone: buyers, sellers and couriers all have their place.",
      how: ["Create a free account in seconds.", "Pick your role: buyer, seller or courier.", "Get a dedicated space for your profile."],
      functions: ["Buyer, seller and courier dashboards", "Custom storefronts for sellers", "100% free sign-up"],
    },
  },
  simple: {
    fr: {
      title: "Simple", subtitle: "Facile à utiliser partout",
      desc: "Une expérience fluide et intuitive, aussi bien sur mobile que sur ordinateur.",
      how: ["Recherchez un produit en un clic.", "Ajoutez au panier et commandez facilement.", "Suivez votre livraison en direct."],
      functions: ["Interface bilingue Français / Anglais", "Recherche et filtres rapides", "Design adapté au mobile"],
    },
    en: {
      title: "Simple", subtitle: "Easy to use anywhere",
      desc: "A smooth, intuitive experience on both mobile and desktop.",
      how: ["Search for a product in one click.", "Add to cart and order easily.", "Track your delivery live."],
      functions: ["Bilingual French / English interface", "Fast search and filters", "Mobile-friendly design"],
    },
  },
  rapide: {
    fr: {
      title: "Rapide", subtitle: "Livraison fiable",
      desc: "Vos commandes sont livrées rapidement partout au Togo, avec un suivi en temps réel.",
      how: ["Un livreur prend en charge dès que la commande est prête.", "Suivez sa position en temps réel sur la carte.", "Recevez votre colis en 24 à 72h."],
      functions: ["Carte de suivi GPS en direct", "Livraison standard ou express", "Notifications e-mail à chaque étape"],
    },
    en: {
      title: "Fast", subtitle: "Reliable delivery",
      desc: "Your orders are delivered quickly across Togo, with real-time tracking.",
      how: ["A courier takes over as soon as the order is ready.", "Track their position live on the map.", "Receive your parcel within 24 to 72h."],
      functions: ["Live GPS tracking map", "Standard or express delivery", "Email notifications at every step"],
    },
  },
  communaute: {
    fr: {
      title: "Communauté", subtitle: "Grandissons ensemble",
      desc: "Bien plus qu'une marketplace : une communauté de commerçants et de clients qui grandit ensemble.",
      how: ["Les vendeurs locaux sont mis en avant.", "Les avis et notes sont partagés par tous.", "Un support local basé à Lomé vous accompagne."],
      functions: ["Boutiques de vendeurs locaux", "Avis et notes communautaires", "Assistant IA + équipe locale"],
    },
    en: {
      title: "Community", subtitle: "Growing together",
      desc: "Much more than a marketplace: a community of merchants and customers growing together.",
      how: ["Local sellers are showcased.", "Reviews and ratings are shared by everyone.", "A local team based in Lomé supports you."],
      functions: ["Local seller storefronts", "Community reviews and ratings", "AI assistant + local team"],
    },
  },
  qualite: {
    fr: {
      title: "Qualité", subtitle: "Les meilleurs produits au meilleur prix",
      desc: "Une sélection de produits de qualité, aux meilleurs prix du grand marché d'Assiganme.",
      how: ["Les produits sont validés par l'administration.", "Les prix sont affichés clairement en FCFA.", "Les avis vous aident à bien choisir."],
      functions: ["Catalogue modéré et validé", "Prix transparents en FCFA", "Filtres par prix et par catégorie"],
    },
    en: {
      title: "Quality", subtitle: "The best products at the best price",
      desc: "A curated selection of quality products at the best prices of the great Assiganme market.",
      how: ["Products are approved by the admin.", "Prices are clearly shown in FCFA.", "Reviews help you choose well."],
      functions: ["Moderated, approved catalog", "Transparent FCFA pricing", "Filters by price and category"],
    },
  },
};
